"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProperties = void 0;
const react_1 = __importStar(require("react"));
const api_1 = __importDefault(require("../services/api"));
const PropertiesContext = (0, react_1.createContext)({});
const PropertiesProvider = ({ children }) => {
    const [propContext, setProperties] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        api_1.default.get('properties').then(({ data }) => {
            setProperties(data);
        });
    }, []);
    return react_1.default.createElement(PropertiesContext.Provider, { value: propContext }, children);
};
const useProperties = () => {
    const context = (0, react_1.useContext)(PropertiesContext);
    return context;
};
exports.useProperties = useProperties;
exports.default = PropertiesProvider;
